import React, { Component } from 'react';
import { T } from '../widget/display/T';
import { AppComponent } from '../AppComponent';
import { Button } from '../widget/input/Button/Button';
import { THtml } from '../widget/display/THtml';
import { Link } from 'react-router-dom';
import { PageContent, PageStyle } from '../layout/PageContent/PageContent';

import './LoggedOutPage.scss';
import { Heading } from '../widget/display/Heading/Heading';
import { LogoutReason } from '../../services/SessionService';

interface Props {}

interface State {}

export class LoggedOutPage extends AppComponent<Props, State> {
	constructor(props: Props) {
		super(props);
	}
	render() {

		const logout = this.application.services.sessionService.getLogout();
		const logoutReason = logout && logout.reason ? logout.reason : LogoutReason.User;

		return (
			<div className="Page LoggedOutPage">
				<PageContent style={PageStyle.Gray}>
					<div className="Content">
						<Heading level={1} labelTextkey="Login_YouHaveBeenLoggedOut"/>
						<p>
							<THtml k="Login_LogoutDescription" />
						</p>
						{ logoutReason==LogoutReason.User &&
							<p >
								<THtml k="Login_LogoutDescription_Reason_User" />
							</p>
						}
						{ logoutReason==LogoutReason.Timeout &&
							<p >
								<THtml k="Login_LogoutDescription_Reason_Timeout" />
							</p>
						}
						{ logoutReason==LogoutReason.System &&
							<p >
								<THtml k="Login_LogoutDescription_Reason_System" />
							</p>
						}
						<div>
							<Link to="/login">
								<T k="Login_LoginAgain" />
							</Link>
						</div>
						<br/>
						<div>
							<a href="https://www.landshypotek.se">Gå till Landshypotek</a>
						</div>
						<br/>
						<div>
							<a href="https://secure.landshypotek.se">
								Gå till Internetbanken
							</a>
						</div>
					</div>
				</PageContent>
			</div>
		);
	}
}
